export const getThumbnailUrl = (photo: { thumbnailUrl?: string; src: string }) => {
	return photo.thumbnailUrl || photo.src;
};